import { SearchBaseModel } from '../commonModels';
import { PricelistCurrentModel } from './pricelist-current';

export class PricelistOfferModel extends SearchBaseModel {
  public Items: PricelistCurrentModel[];
  public CustomerId: number;
  public GarageId: number;
  public EmailAdressSeparated: string;
  public EmailAdress: string[];
  public EmailSeparator: string;
  constructor() {
    super();
    this.EmailAdress = new Array();
    this.EmailAdressSeparated = '';
    this.EmailSeparator = ',';
  }
}

export class PricelistCurrentSearchModel extends SearchBaseModel {
  public IsActive: boolean;
  public PricelistId: number;
  public Size: string;
  public TyreSegmentId: number;
  public GarageId: number;
  public Brand: string;
  public SeasonId: number;
  public CustomerId: number;
  public Tread: string;
  public Article: string;
  public Code: string;
  public IsRft: boolean;
  public TyreCarTypeId: number;
  public IsReinforcement: boolean;
  public SpeedIndex: string;
  public HasTyreSupplierOffer: boolean;
  public TyreSupplierId: number;
  public HasPromoCodeValue: boolean;

  constructor() {
    super();
    this.Size = null;
    this.TyreSegmentId = null;
    this.CustomerId = null;
    this.GarageId = null;
    this.Brand = null;
    this.SeasonId = null; 
    this.Tread = null;
    this.Article = null;
    this.Code = null;
    this.IsRft = null;
    this.TyreCarTypeId = null;
    this.IsReinforcement = null;
    this.SpeedIndex = null;
    this.HasTyreSupplierOffer = null;
    this.TyreSupplierId = null;
  }
}

